import { useRef, useState } from 'react';
import { createPortal } from 'react-dom';

/** Single-line text with an ellipsis; shows a styled tooltip with the full text only when it is actually truncated. */
export const TruncatedText = ({ text, className = '' }: { text: string; className?: string }) => {
  const ref = useRef<HTMLSpanElement>(null);
  const [position, setPosition] = useState<{ left: number; top: number; above: boolean } | null>(null);

  const show = () => {
    const element = ref.current;
    if (!element || element.scrollWidth <= element.clientWidth) return;
    const rect = element.getBoundingClientRect();
    const above = rect.bottom + 80 > window.innerHeight;
    setPosition({ left: Math.min(rect.left, window.innerWidth - 376), top: above ? rect.top - 8 : rect.bottom + 8, above });
  };

  return <>
    <span ref={ref} className={`truncated-text ${className}`.trim()} onMouseEnter={show} onMouseLeave={() => setPosition(null)}>{text}</span>
    {position ? createPortal(<div role="tooltip" className={`truncated-text-tooltip${position.above ? ' above' : ''}`} style={{ left: Math.max(8, position.left), top: position.top }}>{text}</div>, document.body) : null}
  </>;
};
